var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXlsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29 0h16.063l13.595 14.19v27.556c0 3.451-2.786 6.254-6.237 6.254H6.29C2.856 48 .053 45.197.053 41.746V6.236C.053 2.803 2.856 0 6.289 0z",
    fill: "#00733B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.336 0v14.067h13.612L22.336 0z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.979 34.949h-2.33l-1.595-2.68-1.594 2.68H7.113l2.768-4.66-2.435-4.047h2.347l1.261 2.102 1.244-2.102h2.348l-2.418 4.064 2.75 4.643zm.823 0v-8.707h2.225v6.815h3.784v1.892H15.8zm9.687.105a3.56 3.56 0 01-2.312-.823c-.648-.526-1.016-1.192-1.069-1.98l1.91-.56c.052.42.228.788.526 1.068.315.28.665.42 1.05.42.316 0 .579-.07.789-.21a.675.675 0 00.298-.56c0-.193-.088-.35-.246-.49a2.23 2.23 0 00-.613-.316 8.074 8.074 0 00-.84-.245 5.861 5.861 0 01-.93-.333 3.268 3.268 0 01-.84-.473c-.263-.175-.456-.438-.613-.771a2.54 2.54 0 01-.245-1.139c0-.718.297-1.314.91-1.787.614-.49 1.35-.718 2.208-.718.858 0 1.611.21 2.242.613.63.42 1.034.964 1.191 1.63l-1.997.84a1.744 1.744 0 00-.508-.893 1.399 1.399 0 00-.928-.333c-.28 0-.49.07-.666.175a.513.513 0 00-.228.456c0 .175.105.333.316.455.21.105.49.193.806.246a6.382 6.382 0 012.085.736c.314.175.577.472.788.858.227.403.332.876.332 1.419 0 .806-.315 1.471-.946 1.962-.63.49-1.453.753-2.47.753z",
    fill: "#fff"
  })));
}

export default SvgXlsIcon;